<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
  >
    <path
      d="M15.63,8.49l.35.35.34-.35L21,3.87h6.42L32,8.35v6.31L19.17,28.13H12.78L0,14.66V8.35L4.5,3.87h6.42Z"
    />
  </svg>
</template>
